var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaxMaster(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "29-Tax"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29.71 8.29-6-6A1 1 0 0 0 23 2H11a3 3 0 0 0-3 3v6a1 1 0 0 0 2 0V5a1 1 0 0 1 1-1h11v3a3 3 0 0 0 3 3h3v17a1 1 0 0 1-1 1h-8a1 1 0 0 0 0 2h8a3 3 0 0 0 3-3V9a1 1 0 0 0-.29-.71zM24 7V5.41L26.59 8H25a1 1 0 0 1-1-1z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14a8 8 0 1 0 8 8 8 8 0 0 0-8-8zm0 14a6 6 0 1 1 6-6 6 6 0 0 1-6 6z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.29 19.29-4 4a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l4-4a1 1 0 0 0-1.42-1.42z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 20,
    r: 1,
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 24,
    r: 1,
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 8h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2zM25 13h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2zM25 18h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2zM25 23h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxMaster);
export default __webpack_public_path__ + "static/media/tax-master.bdd964fd3ac03ac3cb39f733c556da39.svg";
export { ForwardRef as ReactComponent };